import React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/AgentArrivalHypothesisModal/AgentArrivalForm';

type Props = {
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
};

export default function AgentETPSelector(props: Props): React.ReactElement {
    const { t } = useTranslation();

    const { formState, setFormState } = props;

    const values = Array.from({ length: 10 }, (_, i) => 0.1 * (i + 1));

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth>
                <InputLabel>{t('humanResources.etp')}</InputLabel>
                <Select
                    value={formState.agentETP}
                    onChange={(event) =>
                        setFormState({
                            ...formState,
                            agentETP: event.target.value as number,
                        })
                    }
                    label={t('humanResources.etp')}
                >
                    <MenuItem value="" disabled>
                        {t('humanResources.etp')}
                    </MenuItem>
                    {values.map((value, index) => (
                        <MenuItem value={value} key={index}>
                            {value.toFixed(1)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
